<template>
    <div v-if="mostrarModalAnotacoes" class="modal fade show"  tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header" style="background-color: #1d4875; color: white;">
                    <h5 class="modal-title" style="text-align: center;">Anotações do Processo - {{ processo.codigo_processo }}</h5>
                    <button type="button" class="close" @click="fecharModalAnotacoes" style="color: white;">&times;</button>
                </div>



        <div class="modal-body">
            <fieldset>
                <div class="row">
                    <div class="col-3">
                        <label style="color:black">Anotações Gerais:</label><br />
                        <button v-for="anotProc in anotacoesProcesso" :key="anotProc.id" type="button"
                            title="Carregar anotação" @click="loadAnotacaoProcesso(anotProc.id)"
                            class="btn btn-sm btn-link">
                            {{ anotProc.usuario_cadastro }} em {{ new Date(anotProc.updated_at).toLocaleString('pt-BR')
                            }}
                        </button>
                        <span v-if="anotacoesProcesso.length <=0">Nenhuma anotação feita neste processo.</span>
                        <button type="button" title="Nova Anotação"
                            class="btn btn-primary btn-sm btn-block btn-left-align" @click="NovaAnotacaoProc">
                            Adicionar Anotação
                        </button>
                        <br />
                    </div>
                    <div class="col-9">
                        <form method="post" enctype="multipart/form-data">
                            <div v-if="isAdmin">
                                <textarea cols="60" rows="6" maxlength="500" wrap="hard"
                                    :placeholder="`Insira aqui as anotações do processo ${processo.codigo_processo}.`"
                                    class="form-control" v-model="anotacaoProcesso" :disabled="!canEditProc"></textarea>
                                <input type="number" min="0" max="10" step="0.01" :placeholder="`Atribuir nota ao processo ${processo.codigo_processo}.`" class="form-control"
                                    style="text-align: left" v-model="notaProcesso"
                                    :disabled="!canEditProc" />
                                <br />
                                <button :disabled="!canEditProc" type="button" class="btn btn-primary btn-sm btn-save"
                                    @click="SalvarAnotacao('processo')"
                                    :title="(idAnotacaoProcessoSelecionada == 0 ? 'Salvar' : 'Editar') + ' Anotação do Processo'">
                                    {{ idAnotacaoProcessoSelecionada == 0 ? 'Salvar' : 'Editar' }} Anotação do Processo
                                </button>
                                <button :disabled="!canDeleteAnotProc" type="button"
                                    class="btn btn-danger btn-sm btn-delete" @click="DeletarAnotacao('processo')"
                                    title="Deletar Anotação">
                                    Deletar Anotação
                                </button>
                            </div>
                            <div v-else>
                                <textarea cols="60" rows="6" maxlength="500" wrap="hard"
                                    :placeholder="`Insira aqui as anotações do processo ${processo.codigo}.`"
                                    class="form-control" v-model="anotacaoProcesso" :disabled="!canEditProc"></textarea>
                                <br />
                                <button :disabled="!canEditProc" type="button" style="width: 100%;"
                                    class="col-12 btn btn-primary btn-sm btn-save" @click="SalvarAnotacao('processo')"
                                    title="Salvar Anotação do Processo">
                                    Salvar Anotação do Processo
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-2">
                        <label style="color:black">Petições</label><br />
                        <div v-for="peticao in processo.peticoes" :key="peticao.id">
                            <button type="button"
                                :id="`AnotPet${peticao.id}`" title="Buscar petição" class="btn btn-link" style="text-align: left;"
                                @click="SelecionarPeticao(peticao)">
                                {{ peticao.descricao ? peticao.descricao : "(Sem descrição)" }}
                            </button><br />                        
                        </div>
                    </div>
                    <div class="col-2">
                        <label style="color:black">Anotações na petição {{ (peticaoSelecionada ? peticaoSelecionada.descricao : '') }} </label><br />
                        <button v-for="anotPet in anotacoesPeticao" :key="anotPet.id" type="button"
                            title="Carregar anotação" @click="loadAnotacaoPeticao(anotPet.id)" style="text-align: left;"
                            class="btn btn-sm btn-link">
                            {{ anotPet.usuario_cadastro }} em {{ new Date(anotPet.updated_at).toLocaleString('pt-BR') }}
                        </button>
                        <span v-if="anotacoesPeticao.length <=0">Nenhuma anotação feita nesta petição.</span>
                        <button type="button" title="Nova Anotação"
                            class="btn btn-primary btn-sm btn-block btn-left-align" @click="NovaAnotacaoPet">
                            Adicionar Anotação
                        </button>
                        <br />
                    </div>
                    <div class="col-8">
                        <form method="post" enctype="multipart/form-data">
                            <textarea id="anotacaoPeticao" rows="4" maxlength="500" wrap="hard"
                                :placeholder="peticaoSelecionada && peticaoSelecionada.descricao 
                                    ? `Anotações para a petição '${peticaoSelecionada.descricao}'` 
                                    : 'Anotações para a petição.'"
                                class="form-control" v-model="anotacaoPeticao"
                                :disabled="!(canEditPet && peticaoSelecionada)"></textarea>
                            <input v-if="isAdmin" type="number" min="0" max="10" step="0.01"
                                :placeholder="peticaoSelecionada && peticaoSelecionada.descricao 
                                    ? `Nota para a petição '${peticaoSelecionada.descricao}'` 
                                    : 'Nota para a petição.'"
                                class="form-control" maxlength="5"
                                v-model="notaPeticao" style="text-align: left;"
                                :disabled="!(canEditPet && peticaoSelecionada)"/>
                            <br />
                            <button type="button" class="btn btn-primary btn-sm btn-save"
                                @click="SalvarAnotacao('peticao')" :disabled="!(canEditPet && peticaoSelecionada)"
                                :title="!isAdmin ? 'Salvar Anotação da Petição' : idAnotacaoPeticaoSelecionada == 0 ? 'Salvar' : 'Editar' + ' Anotação da Petição'">
                                {{ !isAdmin ? 'Salvar' : idAnotacaoPeticaoSelecionada == 0 ? 'Salvar' : 'Editar' }} Anotação da Petição
                            </button>
                            <button v-if="isAdmin" type="button" class="btn btn-danger btn-sm btn-delete"
                                @click="DeletarAnotacao('peticao')"
                                :disabled="!(canDeleteAnotPet && peticaoSelecionada)">
                                Deletar Anotação
                            </button>
                        </form>
                    </div>
<div v-if="isAdmin && funcionalidade_IA_ativa">
                     <processo-i-a-analise 
                        :processo="processo"
                        :peticoes="processo.peticoes"
                        :user-id="loggedUserId">
                    </processo-i-a-analise>
                </div>

                </div>
                <hr />
            </fieldset>
            <br />
            <span style="color: gray;">* As anotações feitas aqui não aparecerão no processo.</span>
        </div>





            </div>
        </div>
    </div>
    
</template>
    
    <script>
    import axios from 'axios';

import ProcessoIAAnalise from './ProcessoIAAnalise.vue';

    export default {
        props: {
            mostrarModalAnotacoes: {
                type: Boolean,
                required: true
            },
            processo: {
                type: Object,
                required: true
            },
            user: {
                type: Object,
                required: true
            }
        },
        components: {
            ProcessoIAAnalise
        },
        data() {
            return {
                baseUrl: window.Laravel.baseUrl, // Pega o valor da variável global

                anotacaoProcesso: '',
                notaProcesso: '',
                idAnotacaoProcessoSelecionada: 0,
                userNameAnotacaoSelecionada: '',
                anotacoesProcesso: [],
                anotacaoPeticao: '',
                notaPeticao: '',
                idAnotacaoPeticaoSelecionada: 0,
                idPeticaoSelecionada: 0,
                anotacoesPeticao: [],
                isAdmin: false,
                loggedUserName: '',
                loggedUserId: null,
                canEditProc: false,
                canDeleteAnotProc: false,
                canEditPet: false,
                canDeleteAnotPet: false,
                peticaoSelecionada: null,
                shouldDismiss: false,

                funcionalidade_IA_ativa: window.Laravel.ATIVAR_FUNCIONALIDADE_IA || false,
            };
        },
        methods: {
            fecharModalAnotacoes() {
                this.$emit('fecharAnotacoes');
            },

            NovaAnotacaoProc() {
                this.resetModal();
                this.canEditProc = true;


                if (!this.isAdmin) {
                    this.candEditProc = !this.isAdmin && this.idAnotacaoProcessoSelecionada > 0;
                }
            },
            loadAnotacaoProcesso(id) {
                this.idAnotacaoProcessoSelecionada = id;
                this.canEditProc = this.isAdmin && this.idAnotacaoProcessoSelecionada > 0;
                this.canDeleteAnotProc = this.isAdmin && this.idAnotacaoProcessoSelecionada > 0;
                this.canEditPet = false;
                this.canDeleteAnotPet = false;
                const anotacoesProcesso = this.anotacoesProcesso.filter(x => x.id == id);
                this.anotacaoProcesso = anotacoesProcesso[0].anotacao_processo;
                this.notaProcesso = parseFloat(anotacoesProcesso[0].nota_processo);
                this.userNameAnotacaoSelecionada = anotacoesProcesso[0].usuario_cadastro;
            },
            SelecionarPeticao(peticao) {
                this.peticaoSelecionada = peticao;
                this.idPeticaoSelecionada = peticao.id;
                this.BuscarAnotacoesPeticao();
            },
            loadAnotacaoPeticao(id) {
                this.idAnotacaoPeticaoSelecionada = id;
                this.canEditPet = true;
                this.canDeleteAnotPet = true;
                this.canEditProc = false;
                this.canDeleteAnotProc = false;
                const anotacoesPeticao = this.anotacoesPeticao.filter(x => x.id == id);
                this.anotacaoPeticao = anotacoesPeticao[0].anotacao_peticao;
                this.notaPeticao = parseFloat(anotacoesPeticao[0].nota_peticao);
                this.userNameAnotacaoSelecionada = anotacoesPeticao[0].usuario_cadastro;
            },
            SalvarAnotacao(origem = 'processo') {
                let payload = {};
                const idAnotacao = (this.idAnotacaoProcessoSelecionada != 0) ? this.idAnotacaoProcessoSelecionada : (this.idAnotacaoPeticaoSelecionada != 0) ? this.idAnotacaoPeticaoSelecionada : 0;

                if ((this.notaPeticao && (parseFloat(this.notaPeticao) < 0 || parseFloat(this.notaPeticao) > 10)) || (this.notaProcesso && (parseFloat(this.notaProcesso) < 0 || parseFloat(this.notaProcesso) > 10))) {
                    return alert(`A nota ${origem === 'processo' ? 'do processo' : 'da petição'} precisa ser entre 0 e 10`);
                }

                if (origem == 'processo') {
                    payload = {
                        anotacao_processo: this.anotacaoProcesso,
                        nota_processo: parseFloat(this.notaProcesso),
                        id_processo: this.processo.id,
                        id: idAnotacao,
                    }
                } else if (origem == 'peticao') {
                    payload = {
                        id_peticao: this.idPeticaoSelecionada,
                        anotacao_peticao: this.anotacaoPeticao,
                        nota_peticao: parseFloat(this.notaPeticao),
                        id_processo: this.processo.id,
                        id: idAnotacao,
                    }
                }

                if (!this.isAdmin) {
                    if (idAnotacao != 0) {
                        if (this.loggedUserName !== this.userNameAnotacaoSelecionada) {
                            alert("Você não pode editar anotação feita por outro usuário.");
                        } else {
                            alert("Usuário sem permissão para editar anotação.");
                        }
                        return;
                    }
                }

                const id = origem == 'processo' ? this.processo.id : this.idPeticaoSelecionada;

                axios.put(`${this.baseUrl}processo/salva_anotacoes_${origem}/${id}/`, payload)
                    .then(res => {
                        alert(res.data);
                        if (origem == 'processo') {
                            this.idAnotacaoProcessoSelecionada = 0;
                            this.BuscarAnotacoesProcesso();
                        } else if (origem == 'peticao') {
                            this.idAnotacaoPeticaoSelecionada = 0;
                            this.BuscarAnotacoesPeticao();
                        }
                    })
                    .catch(err => {
                        alert(`Erro ao salvar anotações ${origem == 'processo' ? 'no processo' : 'na petição'}: ${err}`);
                    })
            },
            DeletarAnotacao(origem = 'processo') {
                if (!this.isAdmin) {
                    return alert('Usuário sem permissão para deletar anotação.');
                }

                if (!window.confirm("Deseja realmente deletar essa anotação?")) {
                    return;
                }

                const id = origem == 'processo' ? this.idAnotacaoProcessoSelecionada : this.idAnotacaoPeticaoSelecionada;

                if (!id) {
                    return alert('Não foi possível remover essa anotação');
                }

                axios.delete(`${this.baseUrl}processo/remove_anotacoes_${origem}/${id}/`)
                    .then(res => {
                        alert("Anotação removida com sucesso");
                        if (origem == 'processo') {
                            this.idAnotacaoProcessoSelecionada = 0;
                            this.BuscarAnotacoesProcesso();
                        } else if (origem == 'peticao') {
                            this.idAnotacaoPeticaoSelecionada = 0;
                            this.BuscarAnotacoesPeticao();
                        }
                    })
                    .catch(err => {
                        alert(`Erro ao remover anotação ${origem == 'processo' ? 'do processo' : 'da petição'}: ${err}`);
                    });
                this.resetModal();
            },
            NovaAnotacaoPet() {
                this.resetModal(false)
                if (!this.peticaoSelecionada) {
                    return alert("As anotações são criadas nas petições. Selecione uma petição.")
                }
                this.canEditPet = true;
            },
            BuscarAnotacoesProcesso() {
                axios.get(`${this.baseUrl}processo/buscar_anotacoes_processo/${this.processo.id}/`)
                    .then(res => {
                        this.anotacoesProcesso = res.data;
                    })
                    .catch(err => {
                        alert('Ocorreu um erro ao buscar as anotações deste processo', err);
                    })
                this.resetModal();
            },
            BuscarAnotacoesPeticao() {
                axios.get(`${this.baseUrl}processo/buscar_anotacoes_peticao/${this.idPeticaoSelecionada}/`)
                    .then(res => {
                        this.anotacoesPeticao = res.data;
                    })
                    .catch(err => {
                        alert('Ocorreu um erro ao buscar as anotações desta peticao', err);
                    })
                this.resetModal(false);
            },
            
            resetModal(processo = true) {
                this.anotacaoProcesso = '';
                this.notaProcesso = '';
                this.anotacaoPeticao = '';
                this.notaPeticao = '';
                this.canEditPet = false;
                this.canEditProc = false;
                this.canDeleteAnotPet = false;
                this.canDeleteAnotProc = false;
                this.userNameAnotacaoSelecionada = '';
                this.idAnotacaoProcessoSelecionada = 0;
                this.idAnotacaoPeticaoSelecionada = 0;
                if (processo) {
                    this.peticaoSelecionada = null;
                }
            },

        },
        mounted() {


            const userData = this.user;
            this.isAdmin = Boolean(userData.is_admin);
            this.loggedUserName = userData.name;
            this.loggedUserId = userData.id;
            this.BuscarAnotacoesProcesso();
        },
    };
    </script>
    
<style scoped>

.modal-dialog {
  max-width: 95vw !important; /* ocupa 95% da largura da tela */
}

.modal-content {
  width: 100%;
  font-size: 1rem;
}

.modal {
    display: block;
    background-color: rgba(0, 0, 0, 0.5);
}

.btn-primary {
    background-color: #1d4875; /* Azul mais escuro padrão do Bootstrap (cor de hover original) */
    border-color: #1d4875; /* Também altera a borda */
}

.btn-primary:hover {
    background-color: #0d6efd; /* Azul mais claro (cor original do botão) */
    border-color: #0d6efd;
}

.form-control::placeholder {
    font-size: 1rem;
    border-radius: 0px;
}

/* CSS padrão para preenchimento do processo */
fieldset {
    border: 1px solid #ccc;
    background-color: #f5f5f5;
    font-size: 1rem;
}

fieldset legend {
    font-size: small; 
    margin-top: -10px; 
    margin-left: 20px;
}

fieldset legend span{
    background-color: white; 
    font-weight: bold; 
    color: #1d4875;
    padding-left: 5px;
    padding-right: 5px;
}
/* FIM do CSS padrão para preenchimento do processo */

input{
    font-size: 1rem;
}

th {
    background-color: #bbb; /* Cor já definida para as linhas pares */
}

tr:nth-child(even) td {
    background-color: #ddd; /* Cor já definida para as linhas pares */
}

tr:nth-child(odd) td {
    background-color: #fff; /* Branco para as linhas ímpares */
}

tr:hover td {
    background-color: #aaa; /* Cor ao passar o mouse, substituindo o efeito zebra temporariamente */
}

.btn-xs {
    @extend .btn-sm;
    font-size: 0.7rem;
    padding: 0.25rem 0.5rem;
    line-height: 1.2;
}
</style>
